
import moment from 'moment'

import DirectionData from'@/models/DirectionData'
import LineTypeData from '@/models/LineTypeData'
import WardData from '@/models/WardData'


var table = {
    name: 'realestate.clients',
    list_views: {
        filters: [
            // {
            //     col: 'status',
            //     type: 'multi-select',
            //     value: [],
            // },
        ],
        sorts: {
            created_at: 'desc'
        },
        columns: [
            {
                key: 'id',
                variant: 'warning'
            },
            'created_at',
            'code',
            'fullname'
        ]
    },
    input_view: {
        forms: [
            // {
            //     col: 'needs_structure',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_direction',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_area_range',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_price_range',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_line_type',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_population_area',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_ward',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'needs_other',
            //     type: 'text',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },

            // {
            //     col: 'splitter_1',
            //     type: 'line',
            //     value: null, // default value
            //     required: false,
            //     visible: true,
            //     colspan:12
            // },

            {
                col: 'label_1',
                type: 'label',
                value: null, // default value
                defaultValue: 'Mô tả nhu cầu chi tiết',
                required: false,
                visible: true,
                colspan:12
            },

            {
                col: 'needs_product',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'needs_purpose',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'needs_client_status',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'needs_urgent_reason',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'needs_support',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'client_mindset',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'client_investment_type',
                type: 'multi-select',
                value: null, 
                required: false,
                visible: true,
                colspan: 4
            },
        ]},
    columns: {
        id: {
            'name': 'id',
            'type': 'id',
            'alias': 'ID'
        },
        needs_structure: {
            'name': 'needs_structure',
            'type': 'text',
            'alias': 'Kết cấu BĐS',
            options: [
                'đất thổ cư',
                'đất CLN',
                'đất Lúa',
                'đất khác',
                'Nhà khác',
                'Nhà cấp 4',
                '1 trệt 1 lầu',
                '1 trệt 2 lầu',
                '1 trệt 3 lầu',
                'Nhà trên 3 lầu',
                'Biệt thự',
                'Chung cư',
                'Nhà mới xây',
                'Nhà cũ',
                'Nhà kho',
                'Nhà trọ',
                'Nhà thô',
            ]
        },
        needs_direction: {
            'name': 'needs_direction',
            'type': 'text',
            'alias': 'Hướng',
            options: DirectionData.data
        },
        needs_area_range: {
            'name': 'needs_area_range',
            'type': 'text',
            'alias': 'Tầm diện tích',
            options: [
                'dưới 45m2',
                '45-80m2',
                '80-100m2',
                '100-200m2',
                '200-1000m2',
                'trên 1000m2'
            ]
        },
        needs_price_range: {
            'name': 'needs_price_range',
            'type': 'text',
            'alias': 'Khoảng giá',
            options: [
                'dưới 700 tr',
                '700-1000',
                '1000-1500',
                '1500-2000',
                '2000-2600',
                '2600-3700',
                '3700-5000',
                'trên 5 tỷ'
            ]
        },
        needs_price_rent_range: {
            'name': 'needs_price_rent_range',
            'type': 'text',
            'alias': 'Khoảng giá thuê',
            options: [
                'Dưới 5tr',
                '5tr - 10tr',
                '10tr - 30tr',
                'Trên 30tr'
            ]
        },
        needs_line_type: {
            'name': 'needs_line_type',
            'type': 'text',
            'alias': 'Loại đường',
            options: LineTypeData.data
        },
        needs_population_area: {
            'name': 'needs_population_area',
            'type': 'text',
            'alias': 'Khu dân cư',
            options: [
                'Golden City',
                'Golden City GD2',
                'NOXH Golden City',
                'Bắc HHH',
                'Tây Khánh 8',
                'Lý Thái Tổ',
                'Nam Kinh',
                'Kênh đào nối dài',
                'Tây Đại Học',
                'Tây Đại Học GD2',
                'Khu AB - Tỉnh đoàn - Nam TB',
                'Khu B4 - Thiên Lộc',
                'Phú Quý',
                'Xẻo Trôm',
                'Xẻo Trôm 3',
                'Tây Sông Hậu',
                'Tây Sông Hậu GD2',
                'Lê Chân',
                'VPMQ',
                'Làng Giáo Viên',
                'Làng Giáo Viên 2',
                'Phú Cường',
                'Khu Chợ Cái Sao',
                'An Châu Central',
                'Khu Chợ Cần Đăng'
            ]
        },
        needs_ward: {
            'name': 'needs_ward',
            'type': 'text',
            'alias': 'Phường',
            options: WardData.data
        },
        needs_other: {
            'name': 'needs_other',
            'type': 'text',
            'alias': 'Nhu cầu cụ thể'
        },

        needs_product: {
            'name': 'needs_product',
            'type': 'text',
            'alias': 'Đối với sản phẩm',
            options: [
                'Thích SP lời nhanh',
                'Thích nền cặp',
                'Thích nền góc',
                'Thích đường chính; lớn',
                'Đúng nhu cầu giá cả ko vấn đề',
                'Chỉ cần giá thấp lướt sóng',
                'Cần nhà hoàn thiện ko phải làm gì thêm',
                'Cần nhà cơ bản về có thể sửa theo ý',
                'DT nhỏ nhưng ngay trung tâm',
                'DT lớn ra ven cũng được',
                'Tin tưởng phong thủy',
                'Ko được dính cống trụ',
                'Nhìn ra công viên bờ sông',
                'Tránh tiếng ồn',
                'Có sân vườn sân oto',
            ]
        },

        needs_purpose: {
            'name': 'needs_purpose',
            'type': 'text',
            'alias': 'KH mua để',
            options: [
                'Để bán lại kiếm lời',
                'Để kinh doanh làm ăn',
                'Cho thuê lấy dòng tiền',
                'Để dành; làm của; giữ tiền; cho con',
                'Để nghĩ dưỡng; về hưu',
                'Để đầu tư dài hạn'
            ]
        },

        needs_client_status: {
            'name': 'needs_client_status',
            'type': 'text',
            'alias': 'Tình trạng KH',
            options: [
                'Chỉ mua sổ đỏ; hoàn thiện',
                'Chịu mua dự án; pháp lý chưa rõ',
                'KH tài chính rất mạnh',
                'KH thường phải vay',
                'Tài chính thoải mái đầu tư; tiêu dùng',
                'Có tài chính riêng; công việc ổn định',
                'Mới đi làm; đang tích lũy tài chính',
                'Chưa tự chủ tài chính'
            ]
        },

        needs_urgent_reason: {
            'name': 'needs_urgent_reason',
            'type': 'text',
            'alias': 'CẦN MUA / BÁN GẤP VÌ',
            options: [
                'Mua kèo khác; vị trí khác',
                'Chạy nợ; trả nợ',
                'NH thanh lý tài sản quá hạn',
                'Ko có nhà ở / Đi nơi khác',
                'Người thân mất; thừa kế',
                'Ly hôn chia tài sản',
            ]
        },

        needs_support: {
            'name': 'needs_support',
            'type': 'text',
            'alias': 'CẦN MG Hỗ trợ',
            options: [
                'Vay NH / xoay vốn tư nhân',
                'Giấy tờ pháp lý sang tên/nhanh',
                'Cuốn nền; san lấp mặt bằng',
                'Thiết kế; xây dựng; giấy phép',
                'Trang thiết bị nội thất'
                
            ]
        },

        client_mindset: {
            'name': 'client_mindset',
            'type': 'text',
            'alias': 'Lưu ý tâm lý KH',
            options: [
                'KH hay trả giá / trả giá sâu',
                'KH ko uy tín; hay nói tới lui',
                'KH lựa kèo thơm; kèo đuối',
                'KH dọ giá rất nhiều sale',
                'KH hay tham khảo rất nhiều sp',
                'KH dễ cáu gắt; mất bình tĩnh',
                'KH yêu cầu khó; khác thường',
                'KH trì hoãn; chưa gấp',
                'KH thường gấp bán',
                'KH dây dưa phải hỏi ý người thân',
                'KH đã hoàn toàn tin tưởng bạn',
                'KH quyết đoán mua nhanh bán nhanh',
                'KH nhiệt tình; cởi mở; chân thật',
                'KH cần bảo mật thông tin mua bán',
                'KH ma lanh; chơi chiêu; lòn; đẩy giá…',
                'KH cẩn thận kỹ lưỡng; sợ rủi ro',
            ]
        },

        client_investment_type: {
            'name': 'client_investment_type',
            'type': 'text',
            'alias': 'LOẠI KH ĐẦU TƯ',
            options: [
                'F0: đầu tư đất ruộng làm dự án; khu quy hoạch; đường tránh… thời hạn lâu dài; chưa có gì',
                'F1: đầu tư đất dự án chưa hạ tầng; sổ đỏ; giấy tay; quyết định… giá rẻ nhưng pháp lý chưa chuẩn',
                'F2: đầu tư đất dự án đã có 1 phần hạ tầng; có CĐT; ra sổ trong vòng 3-6 tháng; hoặc đã có sổ và chuẩn bị cho sang tên',
                'F3: đầu tư khi dự án vừa có sổ đỏ; lướt sóng trong 2-3 tháng đầu mới ra sổ',
                'F4: đầu tư sau khi có sổ; mua lại của các NĐT trước đó; đầu tư an toàn; mua và đợi',
                'F5: mua vào khi dự án đã hoàn thành toàn bộ hạ tầng; đã có tiện ích; chủ yếu để ở hoặc sử dụng',
            ]
        },
    }
}

export default {
    table_name: table.name,
    filter_orders: table.filter_orders,
    list_views: table.list_views,
    input_view: table.input_view,
    columns: table.columns
}